import type { DateInput } from '@fourthwall/utils/dist/timezone'
import map from 'lodash-es/map'
import type { FC } from 'react'
import React from 'react'
import { DateString } from '../../functional/DateString'
import * as S from './Timeline.styled'
import type { Props, TimelineEvent } from './types'
import { getSections } from './utils'

interface Dictionary<T> {
  [index: string]: T
}

export const Timeline: FC<Props> = ({ events, size = 'small' }) => {
  const renderTime = (time?: DateInput) => {
    if (!time || size === 'small') {
      return null
    }

    return (
      <S.Time>
        <DateString date={time} format="h:mma" />
      </S.Time>
    )
  }

  const renderEvent = ({ happenedAt, description }: TimelineEvent, index: number) => (
    <S.Item key={index} $completed={!!happenedAt} $size={size}>
      <S.IconContainer $completed={!!happenedAt} />
      <S.Description>
        <S.Title $size={size}>{description}</S.Title>
        {renderTime(happenedAt)}
      </S.Description>
    </S.Item>
  )

  const renderSection = (section: TimelineEvent[]) => {
    const firstEvent = section[0]

    return (
      <React.Fragment key={firstEvent.id}>
        {firstEvent.happenedAt && (
          <S.DateSection $size={size}>
            <DateString date={firstEvent.happenedAt} format="MMM D" />
          </S.DateSection>
        )}
        {map(section, renderEvent)}
      </React.Fragment>
    )
  }

  const renderTimeline = (sections: Dictionary<TimelineEvent[]>) => map(sections, renderSection)

  return <S.Container $size={size}>{renderTimeline(getSections(events))}</S.Container>
}
